"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var Observable_1 = require("rxjs/Observable");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var skynet_store_kb_impl_1 = require("@synisys/skynet-store-kb-impl");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
function previewDocument(blob) {
    var fileURL = URL.createObjectURL(blob);
    if (is_safari(window)) {
        location.href = fileURL;
    }
    else {
        var openingWindow_1 = window.open(fileURL);
        if (blob.type === 'text/plain') {
            blobToText(blob).then(function (content) {
                openingWindow_1.document.write("<pre>" + content + "</pre>");
            });
        }
    }
    setTimeout(function () {
        URL.revokeObjectURL(fileURL);
    }, 1);
}
exports.previewDocument = previewDocument;
function invalidTextLength(text, expectedLength) {
    return (expectedLength && (!text || (text.trim().length < expectedLength)));
}
exports.invalidTextLength = invalidTextLength;
function is_safari(view) {
    return /constructor/i.test(view.HTMLElement) || view.safari;
}
exports.is_safari = is_safari;
exports.toBase64 = function (file) { return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () { return resolve(reader.result); };
    reader.onerror = function (error) { return reject(error); };
}); };
function base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}
exports.base64ToArrayBuffer = base64ToArrayBuffer;
function blobToBase64(blob) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (res, rej) {
                    var reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = function () {
                        res(reader.result);
                    };
                })];
        });
    });
}
exports.blobToBase64 = blobToBase64;
function blobToText(blob) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (res) {
                    var reader = new FileReader();
                    reader.readAsText(blob);
                    reader.onloadend = function () {
                        res(reader.result);
                    };
                })];
        });
    });
}
exports.blobToText = blobToText;
exports.base64toBlob = function (base64Data, contentType, sliceSize) {
    if (sliceSize === void 0) { sliceSize = 512; }
    var byteCharacters = atob(base64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var byteChunks = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(byteChunks.length);
        for (var i = 0; i < byteChunks.length; i++) {
            byteNumbers[i] = byteChunks.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return Observable_1.Observable.of(blob);
};
function saveByteArray(reportName, byte) {
    var blob = new Blob([byte], { type: 'application/pdf' });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = reportName;
    link.click();
}
exports.saveByteArray = saveByteArray;
function convertObjectToMultilingualString(obj) {
    var builder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var k = _a[_i];
        builder = builder.withValueForLanguage(+k, obj[k]);
    }
    return builder.build();
}
exports.convertObjectToMultilingualString = convertObjectToMultilingualString;
function constructClassifierView(fields, values) {
    var classifierBuilder = new idm_de_core_frontend_1.ValueAccessorPropertiesBuilder();
    for (var i = 0; i < fields.length; i++) {
        classifierBuilder.withNameForValue(fields[i], values[i]);
    }
    return new idm_classifier_service_client_js_1.ClassifierView(classifierBuilder.buildMap());
}
exports.constructClassifierView = constructClassifierView;
function constructClassifier(field, value) {
    return new idm_classifier_service_client_js_1.Classifier(new idm_de_core_frontend_1.ValueAccessorPropertiesBuilder()
        .withNameForValue(field, value)
        .buildMap(), field, field);
}
exports.constructClassifier = constructClassifier;
function constructMainEntity(field, value) {
    return new idm_de_service_client_js_1.MainEntity(new idm_de_core_frontend_1.ValueAccessorPropertiesBuilder()
        .withNameForValue(field, value)
        .buildMap(), field, field);
}
exports.constructMainEntity = constructMainEntity;
function base64ToUTF8(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}
exports.base64ToUTF8 = base64ToUTF8;
function utf8ToBase64(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
    }));
}
exports.utf8ToBase64 = utf8ToBase64;
function isSystemField(metaField) {
    return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_IDENTITY ||
        metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE ||
        skynet_store_kb_impl_1.toLower(metaField.getSystemName()) === 'createduserid' ||
        skynet_store_kb_impl_1.toLower(metaField.getSystemName()) === 'updateduserid' ||
        skynet_store_kb_impl_1.toLower(metaField.getSystemName()) === 'datecreated' ||
        skynet_store_kb_impl_1.toLower(metaField.getSystemName()) === 'dateupdated' ||
        skynet_store_kb_impl_1.toLower(metaField.getSystemName()) === 'lastactionid' ||
        skynet_store_kb_impl_1.toLower(metaField.getSystemName()) === 'lastactioncomment' ||
        skynet_store_kb_impl_1.toLower(metaField.getSystemName()) === 'lastactiondate' ||
        skynet_store_kb_impl_1.toLower(metaField.getSystemName()) === 'wfstateid';
}
exports.isSystemField = isSystemField;
function convertToSnakeCase(rootCategoryId) {
    return rootCategoryId.split(/(?=[A-Z])/).join('_').toLowerCase();
}
exports.convertToSnakeCase = convertToSnakeCase;
function convertToKebabCase(rootCategoryId) {
    return rootCategoryId.split(/(?=[A-Z])/).join('-').toLowerCase();
}
exports.convertToKebabCase = convertToKebabCase;
exports.isImage = function (extension) { return extension === 'png' || extension === 'jpeg' || extension === 'jpg'; };
exports.isPdf = function (extension) { return extension && extension.toLowerCase() === 'pdf'; };
exports.isDoc = function (extension) { return ['doc', 'docx', 'rtf'].indexOf(extension) !== -1; };
exports.isExcel = function (extension) { return ['xlsx', 'xlsm'].indexOf(extension) !== -1; };
exports.isTxt = function (extension) { return extension === 'txt'; };
exports.isPdfFile = function (fileName) { return fileName ? exports.isPdf(fileName.split('.').pop()) : false; };
exports.isMergeableFormat = function (extension) { return exports.isPdf(extension) || exports.isTxt(extension) || exports.isDoc(extension); };
exports.mustConvertedToPdf = function (extension) { return exports.isDoc(extension) || exports.isExcel(extension); };
exports.isComparableFile = function (fileName) { return exports.isComparableFormat(exports.extractExtensionFromFileName(fileName)); };
exports.isComparableFormat = function (extension) { return exports.isPdf(extension) || exports.isDoc(extension) || exports.isTxt(extension) || exports.isImage(extension); };
exports.formatFileSize = function (bytes, decimals) {
    if (decimals === void 0) { decimals = 0; }
    if (bytes === 0) {
        return '0 Bytes';
    }
    var k = 1024;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
};
exports.extractExtensionFromFileName = function (fileName) {
    return fileName ? fileName.split('.').pop() : null;
};
exports.stringifyFieldValue = function (metaFieldType, fieldValue, currentLanguageId) {
    switch (metaFieldType) {
        case idm_kb_service_client_js_1.MetaFieldType.INTEGER_IDENTITY:
        case idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE:
        case idm_kb_service_client_js_1.MetaFieldType.INTEGER:
        case idm_kb_service_client_js_1.MetaFieldType.DECIMAL:
        case idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL:
        case idm_kb_service_client_js_1.MetaFieldType.DATE:
        case idm_kb_service_client_js_1.MetaFieldType.DATE_TIME:
        case idm_kb_service_client_js_1.MetaFieldType.STRING:
        case idm_kb_service_client_js_1.MetaFieldType.BOOLEAN:
        case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE: {
            return fieldValue ? fieldValue + '' : '';
        }
        case idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING: {
            return (fieldValue && fieldValue.getValue(currentLanguageId)) ? fieldValue.getValue(currentLanguageId) : '';
        }
        case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
        case idm_kb_service_client_js_1.MetaFieldType.DOCUMENT:
        case idm_kb_service_client_js_1.MetaFieldType.PARENT:
        case idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY:
        case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT: {
            throw TypeError(metaFieldType + " type not supported.");
        }
        default: {
            throw TypeError("There is no field type " + metaFieldType);
        }
    }
};
exports.multilingualToObj = function (value) {
    var obj = {};
    value.toMap().forEach(function (v, k) {
        obj[k] = v;
    });
    return obj;
};
exports.objToMultilingual = function (obj) {
    var map = new Map();
    Object.keys(obj).forEach(function (k) {
        map.set(+k, obj[k]);
    });
    return idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder().fromMap(map).build();
};
exports.mapToObj = function (map) {
    var obj = {};
    map.forEach(function (v, k) {
        obj[k] = v;
    });
    return obj;
};
exports.objToMap = function (obj) {
    var map = new Map();
    Object.keys(obj).forEach(function (k) {
        map.set(k, obj[k]);
    });
    return map;
};
exports.hasPermission = function (permissions) {
    return Array.from(permissions).some(function (permission) {
        return permission.access !== idm_authorization_client_js_1.Access.DENIED;
    });
};
exports.translateMultilingual = function (text, languageId) {
    if (typeof text === 'object' && text.hasOwnProperty(languageId)) {
        return text[languageId];
    }
    return text;
};
function uniteFilters(filter1, filter2, operator) {
    if (operator === void 0) { operator = '$and'; }
    var _a;
    if (filter1 && filter2) {
        if (Object.keys(filter1).length) {
            if (Object.keys(filter2).length) {
                return _a = {}, _a[operator] = [filter1, filter2], _a;
            }
            else {
                return filter1;
            }
        }
        else {
            return filter2;
        }
    }
    else {
        return filter1 || filter2;
    }
}
exports.uniteFilters = uniteFilters;
//# sourceMappingURL=static-method.js.map